import { Injectable } from '@angular/core';
import DomainEventProvider from 'src/app/core/domain/events/domain_event_provider';

import { ConversationEvent } from './conversation_events';

@Injectable({ providedIn: 'root' })
export class ConversationEventProvider extends DomainEventProvider<ConversationEvent> {}
